/**
 * Centralized Routes Configuration
 * 
 * This file contains all application routes in one place.
 * To add a new route:
 * 1. Import the page component at the top
 * 2. Add a new route object to the routes array with path, component, and optional title
 * 
 * Example:
 * import NewPage from '../pages/NewPage';
 * { path: '/new-page', component: NewPage, title: 'New Page' }
 */

// Import all page components
import Dashboard from '../pages/Dashboard';
import Companies from '../pages/Companies';
import Projects from '../pages/Projects';
import Users from '../pages/Users';
import IoTDevices from '../pages/IoTDevices';
import Equipment from '../pages/Equipment';
import EquipmentSpecs from '../pages/EquipmentSpecs';
import SensorData from '../pages/SensorData';
import Alerts from '../pages/Alerts';
import ApiKeys from '../pages/APIKeys';
import Models from '../pages/Models';
import Units from '../pages/Units';
import ScheduledJobs from '../pages/ScheduledJobs';
import ExternalAPIs from '../pages/ExternalAPIs';
import Profile from '../pages/Profile';

/**
 * Routes Array
 * Each route object contains:
 * - path: URL path for the route
 * - component: React component to render
 * - title: (optional) Page title for the route
 */
const routes = [
  {
    path: '/',
    component: Dashboard,
    title: 'Dashboard',
  },
  {
    path: '/companies',
    component: Companies,
    title: 'Companies',
  },
  {
    path: '/projects',
    component: Projects,
    title: 'Projects',
  },
  {
    path: '/users',
    component: Users,
    title: 'Users',
  },
  {
    path: '/iot-devices',
    component: IoTDevices,
    title: 'IoT Devices',
  },
  {
    path: '/equipment',
    component: Equipment,
    title: 'Equipment',
  },
  {
    path: '/equipment-specs',
    component: EquipmentSpecs,
    title: 'Equipment Specifications',
  },
  {
    path: '/sensor-data',
    component: SensorData,
    title: 'Sensor Data',
  },
  {
    path: '/alerts',
    component: Alerts,
    title: 'Alerts',
  },
  {
    path: '/api-keys',
    component: ApiKeys,
    title: 'API Keys',
  },
  {
    path: '/models',
    component: Models,
    title: 'Models',
  },
  {
    path: '/units',
    component: Units,
    title: 'Units',
  },
  {
    path: '/scheduled-jobs',
    component: ScheduledJobs,
    title: 'Scheduled Jobs',
  },
  {
    path: '/external-apis',
    component: ExternalAPIs,
    title: 'External APIs',
  },
  {
    path: '/profile',
    component: Profile,
    title: 'Profile',
  },
];

export default routes;
